import React from "react";

type Props = {
  fill?: string;
  height?: number;
  width?: number;
};

const IframeIcon = ({fill, height = 24, width = 24}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 15C10.7167 15 10.4792 14.9042 10.2875 14.7125C10.0958 14.5208 10 14.2833 10 14V11C10 10.7167 10.0958 10.4792 10.2875 10.2875C10.4792 10.0958 10.7167 10 11 10H17C17.2833 10 17.5208 10.0958 17.7125 10.2875C17.9042 10.4792 18 10.7167 18 11V14C18 14.2833 17.9042 14.5208 17.7125 14.7125C17.5208 14.9042 17.2833 15 17 15H11ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V8H4V18Z"
      fill={fill || "#9E9E9E"}
    />
  </svg>
);

export default IframeIcon;
